import React, { Fragment, useState, useEffect } from "react";
import Header from "components/Header";
import Footer from "components/Footer";
import { ProductQuery } from "components/products";
import { AddressList, UserLoginForm } from "components/checkout";
import Order from "components/Order";
import AccountDetails from "components/AccountDetails";
import "assets/css/App.css";
import "assets/css/index.css";
import { logout } from "store/auth/actions";
import { destroy } from "store/shop/actions";
import { useDispatch } from "react-redux";
import { API_ENDPOINTS } from "utilities";
import { useUser } from "hooks";

const MyAccount = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const { isUserLoggedIn } = useUser();
  const { data: products } = ProductQuery();
  const dispatch = useDispatch();

  // Process categories from products
  const category_arr = {};
  if (products) {
    products.forEach((product) => {
      if (product?.category?.name) {
        category_arr[product.category.name] = product.category.id;
      }
    });
  }

  // Sample default address (replace with actual data from your backend/user context)
  const defaultAddress = {
    address: JSON.stringify({
      company: "themesflat",
      street: "1234 Fashion Street, Suite 567",
      city: "New York",
      email: "info@fashionshop.com",
      phone: "(212) 555-1234",
    }),
  };
  const address = JSON.parse(defaultAddress?.address || "{}");

  // Shop logout
  const removeShop = () => {
    dispatch(destroy(API_ENDPOINTS.LOGOUT)).then((response) => {
      if (response) {
        window.location.href = "/";
      }
    });
  };

  // User logout
  const logoutUser = () => {
    dispatch(logout(API_ENDPOINTS.AUTH.LOGOUT)).then((response) => {
      if (response?.success) {
        window.location.href = "/products";
      }
    });
  };

  return (
    <Fragment>
      <Header />
      <div className="container my-account-container">
        {!isUserLoggedIn ? (
          <div className="login-section">
            <div className="row">
              <div className="login-form-column">
                <UserLoginForm />
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3">
              <div className="wrap-sidebar-account">
                <ul className="my-account-nav">
                  <li>
                    <span
                      className={`my-account-nav-item ${
                        activeTab === "dashboard" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("dashboard")}
                    >
                      Dashboard
                    </span>
                  </li>
                  <li>
                    <span
                      className={`my-account-nav-item ${
                        activeTab === "orders" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("orders")}
                    >
                      Orders
                    </span>
                  </li>
                  <li>
                    <span
                      className={`my-account-nav-item ${
                        activeTab === "address" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("address")}
                    >
                      Address
                    </span>
                  </li>
                  <li>
                    <span
                      className={`my-account-nav-item ${
                        activeTab === "edit" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("edit")}
                    >
                      Account Details
                    </span>
                  </li>
                  <li>
                    <span className="my-account-nav-item" onClick={logoutUser}>
                      User Logout
                    </span>
                  </li>
                  <li>
                    <span className="my-account-nav-item" onClick={removeShop}>
                      Shop Logout
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Content Section */}
            <div className="col-lg-9">
              <div className="my-account-content account-dashboard">
                {activeTab === "dashboard" && (
                  <div className="mb_60">
                    <h5 className="fw-5 mb_20">Hello, User</h5>
                    <p>
                      From your account dashboard, you can view your{" "}
                      <span
                        className="text_primary"
                        onClick={() => setActiveTab("orders")}
                        style={{ cursor: "pointer" }}
                      >
                        recent orders
                      </span>
                      , manage your{" "}
                      <span
                        className="text_primary"
                        onClick={() => setActiveTab("address")}
                        style={{ cursor: "pointer" }}
                      >
                        shipping and billing address
                      </span>
                      , and{" "}
                      <span
                        className="text_primary"
                        onClick={() => setActiveTab("edit")}
                        style={{ cursor: "pointer" }}
                      >
                        edit your password and account details
                      </span>
                      .
                    </p>
                  </div>
                )}

                {activeTab === "orders" && (
                  <div>
                    <h5>My Orders</h5>
                    <Order />
                  </div>
                )}

                {activeTab === "address" && (
                  <div className="my-account-contents account-address">
                    <AddressList addresses={[address]} />
                  </div>
                )}

                {activeTab === "edit" && (
                  <div>
                    <AccountDetails />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer category={category_arr} />
    </Fragment>
  );
};

export default MyAccount;